export enum Source {
    PROJECTS_LAUNCH = 'projects_launch',
    CONTESTS_LAUNCH = 'contests_launch',
    SQUARESPACE_LAUNCH = 'squarespace_launch',
}
